// extracted by mini-css-extract-plugin
export var buttons = "bC_cD";
export var left = "bC_bN";
export var media = "bC_gJ";
export var right = "bC_cl";
export var section = "bC_d";
export var selected = "bC_bg";
export var signature = "bC_gH";
export var testimonial = "bC_gG";
export var text = "bC_b6";
export var textContainer = "bC_cq";
export var video = "bC_f4";